import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AppConfig } from '@shared/utils/app-config';

@Directive({
    selector: '[utilsDisableImageCaching]',
    standalone: false
})
export class DisableImageCachingDirective implements AfterViewInit, OnChanges {
  @Input('utilsDisableImageCaching') url: string | null = null;

  constructor(private eRef: ElementRef, private appConfig: AppConfig) {}

  ngAfterViewInit(): void {
    this.setSrcValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['url']) {
      this.setSrcValue();
    }
  }

  setSrcValue(): void {
    const element: HTMLImageElement = <HTMLImageElement>this.eRef.nativeElement;
    element.src = this.url ? `${this.url}?t=${Date.now()}` : this.appConfig.statics.defaultUserImage;
  }
}
